import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Banner from "./Banner/Banner";
import { cardData } from "./findInstitutionData";
import apiClient from "../../api/apiClient";
import { API_ENDPOINTS } from "../../api/endpoints";
import Loader from "../../components/Loader/Loader";
import Pagination from "../../components/Pagination/Pagination";
import Filters from "./Filters/Filters";
import { useAuth } from "../../context/AuthContext";
import styles from "./FindInstitution.module.css";

const FindInstitution = () => {
  const { setAuthModal } = useAuth();
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState(null);
  const [organizations, setOrganizations] = useState([]);
  const [filters, setFilters] = useState({
    allType: [],
    instituteType: [],
    regions: [],
    mou: [],
    organization: []
  });
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(9);
  const [totalPages, setTotalPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);

  const fetchInstitutionList = async () => {
    try {
      setLoading(true);
      setApiError(null);

      const params = new URLSearchParams();
      params.append("page", page);
      params.append("per_page", pageSize);

      if (filters.allType.length)
        params.append("allType", filters.allType.join(","));
      if (filters.instituteType.length)
        params.append("instituteType", filters.instituteType.join(","));
      if (filters.regions.length)
        params.append("regions", filters.regions.join(","));
      if (filters.mou.length) params.append("mou", filters.mou.join(","));
      if (filters.organization.length) params.append("organization", filters.organization.join(","));
      const url = `${API_ENDPOINTS.GET_INSTITUTION_LIST}?${params.toString()}`;

      const res = await apiClient({
        url,
        method: "get",
        withAuth: true,
      });

      const apiData = res?.data?.institutions || res?.data;
      setList(apiData?.data || null);
      setTotalPage(Math.ceil(apiData.total / pageSize));
      setTotalRecords(apiData.total);
    } catch (error) {
      setApiError(
        error?.response?.data?.message ||
        error.message ||
        "Something went wrong"
      );
    } finally {
      setLoading(false);
    }
  };

  // Fetch organizations from API
  useEffect(() => {
    const fetchOrganizations = async () => {
      try {
        const response = await apiClient({
          url: 'api/organization',
          method: 'get',
          withAuth: true
        });
        setOrganizations(response.data.organizations || []);
      } catch (error) {
        console.error('Failed to fetch organizations:', error);
        setOrganizations([]);
      }
    };

    fetchOrganizations();
  }, []);

  useEffect(() => {
    fetchInstitutionList();
  }, [filters, page, pageSize]);

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);
    setPage(1);
  };

  return (
    <main className={styles.publicationsPage}>
      <Banner />
      <Filters onFilterChange={handleFilterChange} currentFilters={filters} organizations={organizations} />
      <section className={styles.imparcPartners}>
        <div className={styles.container}>
          <div className={styles.topHeading}>
            <div>
              <h3>
                <span>Our Knowledge</span> Partners
              </h3>
              <h5>Explore our network of leading institutions worldwide</h5>
            </div>
            <div className={styles.showing}>
              <strong>Showing {totalRecords}</strong> institutions
            </div>
          </div>
          <div className={styles.cards}>
            {loading ? (
              <Loader
              // fullscreen={true}
              />
            ) : list.length === 0 && apiError ? (
              <p style={{ textAlign: "center", padding: "20px" }}>
                No data found.
              </p>
            ) : (
              list &&
              list.length &&
              list.map((item) => {
                const { id, logo, institution, address, about, user_id, memberSince } =
                  item.institution_profile;
                return (
                  <div key={id} className={styles.card}>
                    <div className={styles.imageDiv}>
                      <img src={logo} alt={institution} />
                    </div>

                    <h4 title={institution}>{institution}</h4>

                    <p className={styles.location} title={`${item.institution_profile.city}, ${item.institution_profile?.state?.name}, ${item.institution_profile?.country?.name}`}> {item.institution_profile.city}, {item.institution_profile?.state?.name}, {item.institution_profile?.country?.name}</p>
                    <p className={styles.calender}><strong>Member Since:</strong> {memberSince}</p>
                    <p className={styles.withoutIcon}><strong>Partnership Type:</strong> {item.institution_profile.institutionType}</p>
                    <p className={styles.withoutIcon}><strong>MOU Status:</strong> {item.institution_profile.mouStatus}</p>
 
                    <p>{about?.length > 95 ? `${about.slice(0, 95)}...` : (about || "")}</p>
                    <Link className={styles.btn} to={`/institutions/${user_id}`}>
                      View Full Profile
                    </Link>
                  </div>
                );
              })
            )}
          </div>
          <Pagination
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </div>
      </section>
      <section className={styles.ispnBooks}>
        <div className={styles.container}>
          <div class={styles.tagOuter}>
            <span className={styles.tag}>Join Our Network</span>
          </div>

          <h3>
            <span className={styles.highlight}> Become an </span>
            IMPARC Knowledge Partner
          </h3>
          <h5>
            Join a prestigious network of institutions committed to advancing
            knowledge, research, and innovation across disciplines and borders.
          </h5>

          <div className={styles.cards}>
            {cardData.map((card) => (
              <div key={card.id} className={styles.card}>
                <figure>
                  <img src={card.img} alt={card.title} />
                </figure>
                <div className={styles.right}>
                  <h4>{card.title}</h4>
                  <p>{card.description}</p>
                </div>
              </div>
            ))}
          </div>
          <div className={styles.btnOuter}>
            <button
              onClick={() => setAuthModal({ open: true, tab: "signup" })}
              className={styles.button}
            >
              Join Us / Become a Member
            </button>
            <Link className={styles.blue} to={`/policy-terms`}>
              See Benefits &amp; T&amp;Cs
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default FindInstitution;
